import { render, staticRenderFns } from "./BlogComponent.vue?vue&type=template&id=e426bf4e&"
import script from "./BlogComponent.vue?vue&type=script&lang=js&"
export * from "./BlogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports